import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";

declare var ko: any;

export class txnInitSplitList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    public headers: simpleListHeader_template;

    protected getTemplateHtml(): string {

        return  `
                <div class="list-header margin-top w-justify">
                    <div class="w-left">
                        <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Transaction Initiative Split</button>
                    </div>
                    <div class="w-left">
                        ${ this.filter.getHtmlBuild() }
                    </div>
                    <div class="w-right">
                        ${ this.pagination.getHtmlBuild() }
                    </div>
                </div>
         
                <div class="w-list-results transaction-int-list"  id="list-results">
                    <table class="list-results">
                        ${ this.resultInfos.getHtmlBuild() }
                        <thead>
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>
                        <tbody data-bind="foreach: txnInitSplits">        
                            <tr class="cursor" data-bind="click: $parent.onClickView">
                                <td class=""><span data-bind="text: brandName"></span></td>
                                <td class=""><span data-bind="text: userName"></span></td>
                                <td class="align-right"><button class="btn icon border only-icon highlight i-delete" type="button" data-bind="click: $parent.onClickDelete, clickBubble: false"></button></td>\
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
                
                <div id="delete-dialog" class="w-lightbox dark-theme">
                    <div class="lightbox-content ">
                        
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Delete Initiative Split</h3>
                                <button data-bind="event: { click: onClickDeleteDialogHide }" type="button" class="close-btn icon i-close"></button>
                            </div>
                   
                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to permanently delete this Initiative Split?</p>   
                                </div>
                            </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickDeleteDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickDeleteConfirm }" class="btn highlight half" type="button">Delete</button>
                        </div>
                    </div>
                    
                </div>
            `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        let headers = [
            {headerName: "Brand", fieldName: "brandName", subHeaders: []},
            {headerName: "User", fieldName: "userName", subHeaders: []},
            {headerName: "Delete", fieldName: null, subHeaders: []},
        ];
        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, headers);
        this.headers.getTemplateViewModel().orderBy("brandName");
        this.headers.getTemplateViewModel().orderByDirection("ASC");
        this.headers.getTemplateViewModel().orderByAndDirection("brandName_ASC");
    }

    protected getTemplateName(): string {
        return "txnInitSplitList_template";
    }

    public resetPageNumber(): void {
        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the view model data/ functions
        let me = this;
        return {
            orderBy: ko.observable("brandName"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("brandName_ASC"),
            txnInitSplits: ko.observableArray([]),
            splitToDelete: ko.observableArray([]),
            onClickView: function (data, event) {
                me.onClickView(data.idBrand, data.idUser);
            },
            onClickAdd: function (data, event) {
                me.onClickAdd();
            },
            onClickDelete: function(data,event){
                me.onClickDelete(data);
            },
            onClickDeleteDialogHide: function(data, event){
                me.onClickDeleteDialogHide();
            },
            onClickDeleteConfirm: function(data, event){
                me.onClickDeleteConfirm();
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            splitToDelete: this.getTemplateViewModel().splitToDelete,
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
            filter: {
                keyword: this.getTemplateViewModel().filter.filterKeyword
            }
        }
    }


    public onClickDeleteDialogHide() {
        this.toggleDeleteDialogVisibility();
    }

    public onClickDelete(data) {

        this.getTemplateViewModel().splitToDelete(data);
        this.toggleDeleteDialogVisibility();
    }

    protected onClickDeleteConfirm(): void{

        this.toggleDeleteDialogVisibility();

        this.caller.deleteSplit();

    }

    public toggleDeleteDialogVisibility() {
        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


    /**
     *
     * @param id
     */
    public onClickView(idBrand, idUser): void {
        this.caller.viewTxnInitSplit(idBrand, idUser);
    }

    public onClickAdd(): void {
        this.caller.addTxnInitSplit();
    }


    /**
     *
     * @param txnInitSplits
     */
    public setTxnInitSplits(txnInitSplits: Array<{ id: number, name: string, dateCreated: string}>): void {

        this.getTemplateViewModel().txnInitSplits(txnInitSplits);
    }

    /**
     *
     * @param nbResults
     * @param nbPages
     * @param execTime
     */
    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setPaginationTotalCount(totalCount: number):  void {
        this.pagination.setNumberItemToPaginate(totalCount);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/txnInitSplitList_template.ts